export const popoverContainers = {
  general: () => document.getElementById('general-popover-container'),
  notificationViewport: () => document.getElementById('notification-wrapper-popover-container'),
};
